import React from 'react'
import styled from 'styled-components';
import GithubCalendar from 'react-github-calendar'
import ReactTooltip from "react-tooltip"
const Github = () => {
    return (
        <MainContainer style={{ marginTop: "-20px" }}>
            <h1 style={{ color: "#32AFE5", textTransform: "uppercase" }}>my github calender</h1>
            <Container>
                <GithubCalendar username='arnab9593'
                    year={new Date().getFullYear()}
                    blockSize={15} blockMargin={4}
                    fontSize={16}>
                    <ReactTooltip delayShow={20} html />
                </GithubCalendar>
            </Container>
            <h1 style={{ color: "#32AFE5", textTransform: "uppercase" }}>my github statistics</h1>
            <Container>
                <img src="https://github-readme-streak-stats.herokuapp.com?user=arnab9593" alt="" />
                <div>
                    <img src="https://github-readme-stats.vercel.app/api?username=arnab9593" alt="" className="stats" />
                    <img src="https://github-readme-stats.vercel.app/api/top-langs/?username=arnab9593" alt="" />
                </div>
            </Container>
        </MainContainer>
    )
}

const Container = styled.div`
    margin:auto;
    width:80%;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-bottom:50px;
    flex-direction:column;
    border: 1px solid #e9e9e9;
    border-radius:10px 10px 10px 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    padding:30px 0px 30px 0px;
    
    .stats{
        margin-bottom:50px;
    }
`

const MainContainer = styled.div`
    @media (max-width: 20em){
        // display:block;
    }
`

export default Github